import * as actionTypes from "./actionTypes";
import axiosRequest from "../../axios-request/request.methods";

//bi fetched
export const fetchDelaration = (payload) => {
  //console.log("Payload",payload)

  return {
    type: actionTypes.FETCH_DECLARATION,
    formData: payload,
  };
};
// bi started
export const editDelarationStarted = () => {
  // //console.log(formData)
  return {
    type: actionTypes.FETCH_DECLARATION_START,
  };
};

export const editDelarationSuccess = (formData, succMsg) => {
  return {
    type: actionTypes.FETCH_DECLARATION_SUCESS,
    formData: formData,
    succMsg: "Proposal Updated Successfully",
  };
};

// export const fetchDelarationSuccess = (payload, apiPath) => {
//   return (dispatch) => {
//     dispatch(editDelarationStarted());
//     if(apiPath){
//       axiosRequest.put(apiPath, payload).then((res) => {
//         dispatch(fetchDelaration(res?.Declaration));
//       });
//     }else{
//       dispatch(fetchDelaration(payload));
//     }
//   };
// };

export const fetchDelarationSuccess = (payload, apiPath) => {
  return async (dispatch) => {
    dispatch(editDelarationStarted());
    if (apiPath) {
      try {
        const res = await axiosRequest.put(apiPath, payload);
        dispatch(fetchDelaration(res?.Declaration));
        return res; // Return the response
      } catch (err) {
        // Handle errors here if needed
        console.error("Error in fetchDelarationSuccess:", err);
        throw err; // Re-throw the error to propagate it to the caller
      }
    } else {
      dispatch(fetchDelaration(payload));
    }
  };
};

export const editDelarationFail = (errMsg) => {
  return {
    type: actionTypes.FETCH_DECLARATION_FAIL,
    error: errMsg,
  };
};
